// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"StatusScreen_backdrop__VJ_o5","success":"StatusScreen_success__AU5iY","icon":"StatusScreen_icon__fslFA","default":"StatusScreen_default__l6KHu"};